import { useState } from "react";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";
import Overlay, { ActionButton } from "./Overlay";

const MANIFESTO = [
  "Cosmic Dreams is an interconnected fictional universe where ancient mythology, extraordinary heroes, advanced technology, mysterious worlds, and forgotten legends exist within one larger story.",
  "At its heart, Cosmic Dreams explores a simple question: What if the legends of the past were not merely stories, but fragments of a much larger reality?",
  "Across different eras and worlds, powerful individuals rise, ancient forces awaken, forgotten civilizations return, and new technologies reshape the future. Some stories are rooted in mythology. Others emerge from science, technology, mystery, or unexplored worlds. Yet beneath every story lies a hidden connection.",
  "The universe does not follow a single time period or a single world. It moves across time. Ancient legends can influence the present. The present can shape the future. And events in one world can create consequences in another.",
  "Heroes such as Bhargav, Ram, Machu, Garutman, Sahadev, and others are not isolated characters. Each has a different origin, purpose, ability, and journey, yet their stories are pieces of the same expanding universe.",
  "Some inherit the power of ancient legends. Some are born with extraordinary abilities. Some are shaped by technology. And some are connected to forces that humanity has yet to understand.",
  "Alongside these heroes exist ancient mythology, powerful weapons, mysterious civilizations, futuristic technology, unexplored worlds, and secrets buried across different points in time. As the stories unfold, these seemingly separate elements begin to connect.",
  "Every hero has a purpose. Every world has a history. Every legend has a reason. And every story is part of something bigger.",
  "Cosmic Dreams is designed as a long-form cinematic universe, where individual books introduce different characters, worlds, and events while gradually revealing the larger story behind them.",
  "What begins as a single story may eventually become a much bigger journey — one that crosses mythology, time, technology, worlds, and generations of heroes.",
];

const WhatIs = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="universe" data-testid="universe-section" className="relative z-10 px-6 py-28 md:px-16 lg:px-24 lg:py-40">
      <SectionHeading title="WHAT IS COSMIC DREAMS?" />
      <Reveal delay={0.1}>
        <p className="-mt-8 font-serif text-lg md:text-xl tracking-wide text-[#D4AF37]/90">
          One Universe. Countless Stories.
        </p>
        <p className="mt-6 max-w-xl text-sm md:text-base font-light leading-relaxed text-[#A0A0B0]">
          An interconnected fictional universe of ancient mythology, extraordinary heroes, advanced
          technology, mysterious worlds and forgotten legends — where every story is part of something
          bigger.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <ActionButton testid="discover-universe-btn" onClick={() => setOpen(true)}>
          DISCOVER THE UNIVERSE →
        </ActionButton>
      </Reveal>

      <Overlay open={open} onClose={() => setOpen(false)} title="WHAT IS COSMIC DREAMS?" label="The Universe, Explained" testid="universe-overlay">
        <div className="max-w-3xl space-y-6">
          {MANIFESTO.map((p, i) => (
            <p key={i} className="text-sm md:text-base font-light leading-relaxed text-[#A0A0B0]">
              {p}
            </p>
          ))}
          <div className="pt-10">
            <p className="font-serif text-2xl md:text-3xl tracking-wide text-[#F5F5FA]">
              THIS IS THE COSMIC DREAMS UNIVERSE.
            </p>
            <p className="mt-4 font-serif text-xs md:text-sm tracking-[0.35em] text-[#D4AF37] uppercase">
              Dream Beyond Reality.
            </p>
          </div>
        </div>
      </Overlay>
    </section>
  );
};

export default WhatIs;
